import { render } from "./ChatDriver.vue?vue&type=template&id=4ca2e564"
import script from "./ChatDriver.vue?vue&type=script&lang=js"
export * from "./ChatDriver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__